import '@quromedical/utils';
import { first } from '@quromedical/utils';
import { compose, resolveConstant } from '../composer';

const assertCanCreateAdmissionCarePlan = _ref => {
  let {
    carePlans,
    newCarePlan
  } = _ref;

  if (carePlans.length === 0) {
    return undefined;
  }

  const hasActiveCarePlan = carePlans.some(c => c.status === 'active');

  if (hasActiveCarePlan) {
    return {
      type: 'error',
      messages: [`Cannot create a new care plan because there is an active one`]
    };
  }

  const onHoldCarePlans = carePlans.filter(c => c.status === 'on-hold');
  const canCreateCarePlan = onHoldCarePlans.every(c => first(c.instantiatesCanonical) !== (newCarePlan === null || newCarePlan === void 0 ? void 0 : newCarePlan.planDefinition));

  if (canCreateCarePlan) {
    return undefined;
  }

  return {
    type: 'error',
    messages: [`Cannot create a care plan with the same name as the previously paused care plan.`]
  };
};

const CarePlanAssertions = {
  'new-care-plan': [assertCanCreateAdmissionCarePlan]
};
/**
 * a function that takes in a set of parameters and based on that determines if a new care plan can be created
 */

export const validateCarePlanRequest = compose({
  getRuleName: _ref2 => {
    let {
      rule
    } = _ref2;
    return rule;
  },
  assertions: CarePlanAssertions,
  defaultAssertions: [],
  defaultResolver: resolveConstant(true)
});
//# sourceMappingURL=care-plan.js.map